import { useAuthState } from "react-firebase-hooks/auth";

import { useFirebaseAuth } from "../sdk";

export function useIsSignedIn() {
  const auth = useFirebaseAuth();
  const [user] = useAuthState(auth);
  return user != null;
}
